function switchStorePopupGetCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
function switchStorePopupSetCookie(name, value, options = {}) {
    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}
if (!customElements.get('switch-store-popup')) {
    customElements.define('switch-store-popup', class SwitchStorePopup extends HTMLElement {
        constructor() {
            super();
            let _this = this;
            this.delay = this.dataset.delay;
            this.testMode = this.dataset.testMode === 'true';
            this.closeButtons = this.querySelectorAll('.js-close-modal-btn');
            this.popupAlreadyshown = this.testMode ? 'false' : switchStorePopupGetCookie('AnoesesSwitchStorePopup');
            function removeSwitchedParam() {
                let url = new URL(window.location.href);
                if (url.searchParams.has('switched')) {
                    url.searchParams.delete('switched');
                    window.history.replaceState({}, '', url.pathname + (url.search ? url.search : '') + url.hash);
                }
            }
            let switchedParamPresent = window.location.search.indexOf('switched=true') !== -1;
            this.switchedHere = this.testMode ? false : switchedParamPresent;
            if (switchedParamPresent) {
                removeSwitchedParam();
            }
            function hidePopupForever() {
                let lifeTime = new Date();
                lifeTime.setFullYear(lifeTime.getFullYear() + 1);
                switchStorePopupSetCookie('AnoesesSwitchStorePopup', 'true', {secure: true, path: '/', expires: lifeTime});
            }
            let bodyObserver = new MutationObserver(function () {
                if (_this.classList.contains('show') && document.body.lastElementChild !== _this) {
                    document.body.appendChild(_this);
                }
            });
            function closePopup() {
                hidePopupForever();
                _this.classList.remove('show');
                document.querySelector("html").classList.remove("show-modal");
                bodyObserver.disconnect();
            }
            this.closeButtons.forEach(function (closeButton) {
                closeButton.addEventListener('click', closePopup);
            });
            document.addEventListener('click', function (event) {
                if (_this.classList.contains('show') && !_this.contains(event.target)) {
                    closePopup();
                }
            }, true);
            this.querySelectorAll('a.switch-store__item').forEach(function (link) {
                link.addEventListener('click', function () {
                    hidePopupForever();
                })
            });
            if (this.switchedHere) {
                hidePopupForever();
            } else if (this.popupAlreadyshown != 'true') {
                setTimeout(function () {
                    document.body.appendChild(_this);
                    _this.classList.add('show');
                    document.querySelector("html").classList.add("show-modal");
                    bodyObserver.observe(document.body, {childList: true});
                }, this.delay)
            }
        }
    });
}
